
/*
** Strip HTML
*/ 
export function stripHtml(data) {
    if (typeof data !== "string") return "";
    var doc = new DOMParser().parseFromString(data, "text/html");
    return doc.body.textContent || "";
}


// WEBPACK FOOTER //
// ./src/data/helpers/strip-html.js